import { createContext } from 'react'
import { UseNotificationsManager } from './use-notifications-manager'

const noop = () => undefined

const defaultValue: UseNotificationsManager = {
  notifications: [],
  setNotifications: noop,
  setNotification: noop,
  clearNotifications: noop,
  clearNotification: noop,
}

const NotificationsContext = createContext<UseNotificationsManager>(
  defaultValue
)

export default NotificationsContext
